import React from 'react';
import { withRouter } from 'react-router-dom';
import { user_token } from '../helpers/Global';
import img_money from '../assets/img/money.png';


class FactureJournal extends React.Component {

    componentDidMount() {
        this.props.setCurrentPage('facture_journal');
        window.scrollTo(0, 0);
    }

    render() {
        const facture = this.props.selected_facture || {};
        const listecolis = facture.colis;
        
        return (
            <React.Fragment>
                <div class="row">
                    <div class="container">
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="card shadow-sm border-0 mb-4 overflow-hidden">
                                    <div class="card-body p-0">
                                        <div class="row no-gutters">
                                            <div class="col-7 p-4">
                                                <h6 class="subtitle template-primary">Facture N° {facture.facture_num}</h6><br />
                                                <h4><strong class="font-weight-light">{facture.str_total_credit}</strong> </h4>
                                                
                                            <div class="row">
                                                <input type="text" value={`${facture.created_at}`} class="form-control-sm form-control datepicker border-0" readonly placeholder="" />
                                            </div>
                                            </div>
                                            <div class="col-5">
                                                <img src={img_money} alt="" class="right-img float-right mnh-100 mw-100" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="container">
                        <div className="card border-0 shadow-sm mb-4">
                            <div className="card-header">
                                <h6>Liste des colis</h6>
                            </div>
                            <div className="card-body">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>{facture.totalcolis} colis</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listecolis.map((coli, indice) =>
                                            <React.Fragment key={indice + coli.barecode}> 
                                                <tr className="footable-detail-row">
                                                    <td>
                                                        <table className="footable-details table table-bordered table-striped">
                                                            <tbody>
                                                                <tr className="show-info-colis">
                                                                    <th>Code</th>
                                                                    <td>
                                                                        {coli.code_colis}
                                                                    </td>
                                                                </tr>

                                                                <tr className="show-info-colis">
                                                                    <th>Prix total</th>
                                                                    <td>
                                                                        {coli.price_colis}
                                                                    </td>
                                                                </tr>

                                                                <tr className="show-info-colis">
                                                                    <th>Comission</th>
                                                                    <td>
                                                                        {coli.comission}
                                                                    </td>
                                                                </tr>

                                                                <tr className="show-info-colis">
                                                                    <th>Crédit</th>
                                                                    <td>
                                                                        {coli.reste}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>


            </React.Fragment>
        );
    }

}

export default withRouter(FactureJournal);